const api = abp.services.api.measurementChartClientApi;

const service = {
  saveChartScaling: (chartName, xMin, xMax, yMin, yMax) =>
                    api.saveChartState(chartName, xMin, xMax, yMin, yMax),
};

export default service;



// WEBPACK FOOTER //
// ./App/components/modules/measurement-chart/service.js